<template>
  <div id="pay">
    <!-- 顶部显示 -->
    <section class="payTop">
      <div id="chooseAddress" class="please">
        <oSelect @changeOption="onChangeOption" :selectData="selectData"></oSelect>
      </div>
      <!--<p @click="toChangeLocation"><i></i>{{this.site}}<span><img class="right2" src="/static/img/rightArr.png" alt=""></span></p>-->
    </section>
    <!-- 中间部分列表 -->
    <section class="payMid">
      <h5>请选择需要缴费的项目:</h5>
      <ul>
        <li v-for="(item,index) in items" @click="singleSelect(item)">
          <div class="div1">
            <img v-show="item.ischecked" class="img1" src="../../../static/img/pitch-on.png">
            <img v-show="!item.ischecked" class="img2" src="../../../static/img/pitch-on-no.png">
          </div>
          <div class="div2">
            <p class="">
              <!--<span class="spa1 ">费项：</span>-->
              <span class="spa4 ">{{item.feename}}</span>
              <span class="spa5 ">{{item.uncollected_amount.toFixed(2)}}元</span>
            </p>
            <p>
              <span class="spa1">缴费截止日期：</span>
              <span class="spa3" :class="{pink:item.isMore}"> {{item.receipt_enddate}}</span>
            </p>
            <p>
              <span class="spa1">计费日期：</span>
              <span class="spa2">{{item.cost_startdate}} 至 {{item.cost_enddate}}</span>
            </p>
          </div>
        </li>
      </ul>
      <p class="bottom-hei"></p>
    </section>
    <!-- 底部合计部分 -->
    <footer class="clear">
      <p class="float-l p1">
        <img @click="allSelect" v-show="allData.check" class="img1" src="../../../static/img/pitch-on.png">
        <img @click="allSelect" v-show="!allData.check" class="img2" src="../../../static/img/pitch-on-no.png">
      </p>
      <p @click="allSelect" class="float-l p2">全选</p>
      <p class="float-r p4" @click="payBtn">缴费</p>
      <div class="float-r wenzi">
        <p class="p5" v-if="this.discount_amount !== '0.00'">优惠：- &yen;&nbsp;<span >{{this.discount_amount}}</span></p>
        <p :class="this.discount_amount !== 0 ? 'p3' : 'p31'" v-if="this.payable_amount !== '0.00'">实付：<span >&yen;&nbsp;{{this.payable_amount}}</span>
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
  import oSelect from '../Son/select.vue'//引入子组件
  export default {
    components: {
      'oSelect': oSelect, //注册组件
    },
    data() {
      return {
        currentTime: "", //当前时间的时间戳
        pitchOn: true,
        totalAmount: [],
        items: [],
        feeids: [],
        feeidsA:[],
        weChat: {},
        allData: {check: false},
        totalPrice: 0,
        clicktag: 0,
        discount_amount: 0,
        payable_amount: 0,
        selectData: {
          defaultIndex: 0,//默认选中是第几个
          selectStatus: false,//通过这个来控制下拉框的显示和隐藏
          selectOptions: [],//下拉框中的参数
          leap: false
        }
      }
    },
    mounted() {
      let vm = this
      vm.currentData();//获取当前时间
      sessionStorage.setItem('pay', window.location.href)
      if (vm.$route.params.house) {
        vm.selectData.selectOptions = vm.$route.params.house
        sessionStorage.setItem('houseid', vm.selectData.selectOptions[0].id)
        vm.confimBilList()
      }
      else {
        vm.postRequest('house/queryByUserId', {}, function (data) {
          vm.selectData.selectOptions = data
          sessionStorage.setItem('houseid', vm.selectData.selectOptions[0].id)
          if(vm.$route.params.houseId){
            sessionStorage.setItem('houseid', vm.$route.params.houseId)
            data.forEach((v,i)=>{
              if(vm.$route.params.houseId === v.id){
                vm.selectData.defaultIndex = i
              }
            })
          }
          vm.confimBilList()
        })
      }
    },
    methods: {
      //选择下拉的列表
      onChangeOption(index, id, name) {
        this.selectData.defaultIndex = index
        sessionStorage.setItem('houseid', id)
        sessionStorage.setItem('el', name)
        this.confimBilList()
      },

      confimBilList() {
        const _this = this
        _this.postRequest('payMent/confimBilTotalList', {
          houseId: sessionStorage.getItem('houseid')
        }, function (data) {
          if(data.feeDatas === null){
            _this.items = []
          }else{
            _this.items = data.feeDatas.confirmBills
            _this.items.forEach((val) => {
              let flag = val.receipt_enddate < _this.currentTime;
              if(flag){
                _this.feeidsA.push(val.feeids)
              }
              val.ischecked = flag
              val.isMore = flag;
              val.disable = flag;
            })
          }
          _this.leap = data.leap
          if(_this.feeidsA.length !== 0){
			      _this.postRequest('payMent/confirmAmount', {
	            pk_feeids: _this.feeidsA.join(',')
	          }, function (data) {
	            console.log(data)
	            _this.payable_amount = data.payableAmount
	            _this.discount_amount = data.adjust_amount
	            _this.totalPrice = data.accruedAmount
	            _this.feeidsA = []
	          })
          }else{
            _this.payable_amount = '0.00'
            _this.discount_amount = '0.00'
          }
        })
      },
      discounts(){
        const _this = this
        console.log(_this.feeidsA)
        _this.items.forEach((val) => {
          let flagA = _this.items && _this.items.length > 0;
          if (val.ischecked) {
            _this.feeidsA.push(val.feeids)
          }else{
            flagA = false;
          }
          _this.allData.check = flagA;
        })
        if(_this.feeidsA.length === 0){
          _this.payable_amount = '0.00'
          _this.discount_amount = '0.00'
        }else{
          _this.postRequest('payMent/confirmAmount', {
            pk_feeids: _this.feeidsA.join(',')
          }, function (data) {
            console.log(data)
            _this.payable_amount = data.payableAmount
            _this.discount_amount = data.adjust_amount
            _this.totalPrice = data.accruedAmount
            _this.feeidsA = []
          })
        }
      },
      currentData() {
        let myDate = new Date();
        let getFullYear = myDate.getFullYear();    //获取完整的年份(4位,1970-????)
        let getMonth = ("0" + (myDate.getMonth() + 1)).slice(-2);//获取当前月份(0-11,0代表1月)
        let getDate = ("0" + (myDate.getDate())).slice(-2);//获取当前日(1-31)
        this.currentTime = getFullYear + '.' + getMonth + '.' + getDate
      },
      refresh() {
        const _this = this
        let flag = _this.items && _this.items.length > 0;
        _this.payable_amount = 0;
        _this.discount_amount = 0
        _this.totalPrice = 0
        _this.items.forEach((val) => {
          if (val.ischecked) {
            _this.payable_amount += val.payable_amount
            _this.discount_amount += val.discount_amount
            _this.totalPrice += val.uncollected_amount
          }
          else {
            flag = false;
          }
        })
        _this.allData.check = flag;
      },

      allSelect() {
        this.items.forEach((value) => {
          if (!value.disable)
            value.ischecked = !this.allData.check
        })
        // this.refresh();
        this.discounts()
      },

      singleSelect(item) {
        if (item.disable)
          return;
        item.ischecked = !item.ischecked
        let dt = item.receipt_enddate
        if (item.ischecked && !this.leap) {
          this.items.forEach(val => {
            if (dt >= val.receipt_enddate) {
              val.ischecked = true
            }
          })
        } else if (!item.ischecked && !this.leap) {
          this.items.forEach(val => {
            if (dt <= val.receipt_enddate) {
              val.ischecked = false
            }
          })
        }
        // this.refresh();
        this.discounts()
      },
      payBtn() {
        let feeidss = []
        this.totalAmount = []
        this.feeids = []
        if (this.clicktag === 0) {
          this.items.forEach((value) => {
            if (value.ischecked) {
              this.totalAmount.push(value.feeids)
              feeidss.push(value)
              value.confirmBills.forEach((val) => {
                this.feeids.push(val)
              })
            }
          })
          let amount = this.totalAmount.toString()
          let valFeeids = JSON.stringify(this.feeids)
          if (amount) {
            this.clicktag = 1
            const _this = this
            _this.postRequest('payment/order/addPayMent', {
              houseId: sessionStorage.getItem('houseid'),
              pk_feeids: amount,
              feeids: valFeeids,
              client_ip: sessionStorage.getItem('userIp')
            }, function (data) {
              _this.clicktag = 0
              if (data.cellType === "URLPAGE") {
                window.location.href = data.paymentUrl
                _this.totalAmount = []
                _this.feeids = []
              } else if (data.cellType === "WXJS") {
                _this.weChat = eval('(' + data.weChatJsSignDatas + ')')
                _this.$router.push({
                  name: 'payment',
                  params: {
                    paymentList: feeidss,
                    rental: _this.totalPrice,
                    wxWech: _this.weChat,
                    discount_amount: _this.discount_amount,
                    payable_amount: _this.payable_amount
                  }
                })
                _this.totalAmount = []
                _this.feeids = []
              }
            })
          } else {
            alert('请选择缴费项')
          }
        }
      }
    }
  }
</script>
<style scoped>
  .pink {
    color: red;
  }

  .clear {
    overflow: hidden;
    zoom: 1;
  }

  .float-l {
    float: left;
  }

  .float-r {
    float: right;
  }

  .spa1 {
    color: rgba(153, 153, 153, 1);
    margin: 0 1px 0 5px;
  }

  .spa2 {
    margin-left: 0px;
  }

  .spa3 {
    margin-left: -20px;
  }

  .spa4 {
    /*margin-left:1px;*/
    color: #F7B932;
  }

  .spa5 {
    float: right;
    color: #F7B932;
  }

  .bottom-hei {
    width: 100%;
    height: 120px;
  }

  #pay {
    background-color: #f5f5f5;
    box-sizing: border-box;
  }

  .payTop {
    height: 154px;
    padding: 32px 34px 29px 31px;
    box-sizing: border-box;
    background-color: #fff;
    margin-bottom: 10px;
  }

  /* 中间部分的样式 */
  .payMid {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    padding: 31px 28px 0px 31px;
    box-sizing: border-box;
  }

  .payMid h5 {
    font-size: 26px;
    font-weight: 400;
    text-align: left;
    margin-bottom: 40px;
    color: #999;
  }

  .payMid .itemTime {
    margin-right: 30px;
  }

  .payMid ul li {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    font-size: 25px;
    text-align: left;
    overflow: hidden;
    zoom: 1;
    margin-bottom: 40px;
    border-radius: 10px;
    background-color: #fff;
    /*box-shadow: 4px 2px 6px 3px #ebebeb;*/
  }

  .payMid ul li > div {
    float: left;
  }

  .payMid ul li .div1 img {
    width: 30px;
    height: 30px;
    margin: 15px 20px 0 0;
  }

  .payMid ul li .div2 {
    width: 90%;
  }

  .payMid ul li .div2 p {
    font-size: 32px;
    line-height: 60px;
  }

  /* 切换样式为单选框 */
  input[type="checkbox" ] {
    -webkit-appearance: radio;
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    outline: none;
  }

  .payMid #single {
    -webkit-border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    border-radius: 10px;
  }

  /* 底部的样式 */
  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 120px;
    padding-left: 30px;
    box-sizing: border-box;
    font-size: 28px;
    background: #fff;
    box-shadow: 2px 2px 30px rgba(200, 200, 220, 0.88);
  }

  footer div {
    text-align: left;
  }

  footer .p1 {
    margin-top: 5px;
    line-height: 120px;
  }

  footer .p1 img {
    width: 30px;
    height: 30px;
  }

  footer .p2 {
    margin: 0 20px 19px;
    line-height: 120px;
  }

  /*实付二字*/
  footer .p3 {
    margin-right: 10px;
    color: #000;
    font-size: 28px;
  }

  /*实付后面的金额*/
  footer .p3 span {
    font-size: 32px;
    color: #F7B932;
    font-weight: 500;
  }

  footer .p31 span {
    margin-right: 10px;
    color: #F7B932;
    line-height: 85px;
    font-size: 32px;
    /*margin-top: 30px;*/
  }

  /*实惠和优惠的整体*/
  footer .wenzi {
    margin: 20px 80px 0 0;
    line-height: 40px;
  }

  /*优惠的一行*/
  footer .p5 {
    margin-right: 10px;
    font-size: 28px;
    color: #FE3B3B;
  }

  /*优惠后面的金额*/
  footer .p5 span {
    font-weight: 600;
  }

  /*缴费按钮*/
  footer .p4 {
    line-height: 120px;
    width: 180px;
    height: 120px;
    /*margin-top: 7%;*/
    /*margin-right: 28px;*/
    /*border-radius:33px;*/
    background: -webkit-linear-gradient(left, #FFA650, #F7B932); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #FFA650, #F7B932); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #FFA650, #F7B932); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #FFA650, #F7B932); /* 标准的语法 */
    font-size: 30px;
    color: rgba(247, 247, 247, 1);
  }

  /* 请选择 */
  .please {
    display: block;
    line-height: 144px;
    font-size: 26px;
    width: 90%;
    color: #999999;
    margin: 0 auto;
    border-bottom: 1px solid #C1C1C1;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/xinyuan/pay-xinyuan.vue